import React, { useContext } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import styled from 'styled-components';

import Headline2 from '@joinforma/ui/components/Headline2';
import Body2 from '@joinforma/ui/components/Body2';
import TabBar from '@joinforma/ui/components/TabBar';
import TabItem from '@joinforma/ui/components/TabItem';

import PageSkeleton from 'components/common/PageSkeleton';

import { SettingsRoutes } from 'utils/routeGenerator';

import { SETTINGS_PAYMENT_PAGE_ELEMENTS } from 'constants/testSelectors';

import CurrentUserContext from 'contexts/CurrentUserContext';
import { Company } from './types';

const Container = styled.div``;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const MainHeading = styled(Headline2)``;

const SubText = styled(Body2)`
  display: block;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

const TabContainer = styled.div`
  margin-top: 30px;
`;

const StyledTabBar = styled(TabBar)``;

const SettingsLinkAccountsLayout = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const { company }: { company: Company } = useContext(CurrentUserContext);
  const location = useLocation();

  const { marketplace, credit_card } = company.features;

  if (!company) {
    return <PageSkeleton />;
  }

  return (
    <Container data-testid={SETTINGS_PAYMENT_PAGE_ELEMENTS.PAYMENT_CONTAINER}>
      <MainContainer>
        <MainHeading>Linked accounts</MainHeading>
        <SubText>Manage your reimbursement and backup payment info.</SubText>
        <TabContainer>
          <StyledTabBar>
            <TabItem
              active={location.pathname.includes('bank-accounts')}
              to={SettingsRoutes.bankAccounts()}
            >
              Reimbursement
            </TabItem>
            {(marketplace || credit_card) && (
              <TabItem
                active={location.pathname.includes('payment')}
                to={SettingsRoutes.payment()}
              >
                Payment
              </TabItem>
            )}
          </StyledTabBar>
        </TabContainer>
        {children ?? <Outlet />}
      </MainContainer>
    </Container>
  );
};

export default SettingsLinkAccountsLayout;
